import { Close } from "@mui/icons-material";
import { useEffect, useMemo } from "react";

import type { ToolbarButtonEntry } from "contexts/toolbars";
import { toolbarsActions, useDispatchToolbars } from "contexts/toolbars";
import { useStopMarkerCreation } from "features/markers/markerCreationUtils";
import { CloseIconButton } from "features/quickAccessMenu/procore/closeIconButton";
import { Picker } from "features/render";

import { Toolbar } from "../Toolbar";

interface PinsToolbarProps {
    picker: Picker;
    id?: string;
}

/**
 * Toolbar with cancel button that appears when pins tool is active
 */
export function PinsToolbar({ picker, id = "pins-toolbar" }: PinsToolbarProps) {
    const toolbarDispatch = useDispatchToolbars();
    const stopMarkerCreation = useStopMarkerCreation();

    const shouldShowToolbar = picker === Picker.Pins;
    const buttons: ToolbarButtonEntry[] = useMemo(
        () => [
            {
                config: {
                    id: "close-pins",
                    icon: <Close />,
                    onClick: stopMarkerCreation,
                    component: CloseIconButton,
                    tooltip: {
                        toolName: "cancel",
                        shortcutKey: "Esc",
                        alwaysVisible: false,
                        placement: "left",
                    },
                },
                state: {
                    active: false,
                    disabled: false,
                    visible: shouldShowToolbar,
                },
            },
        ],
        [stopMarkerCreation, shouldShowToolbar],
    );

    useEffect(() => {
        toolbarDispatch(
            toolbarsActions.addToolbar({
                id,
                buttons,
            }),
        );

        return () => {
            toolbarDispatch(toolbarsActions.removeToolbar(id));
        };
    }, [toolbarDispatch, id, buttons]);

    return <Toolbar id={id} />;
}
